import React from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Action from "../redux/default/reducer";
import GenerateEntries from "../components/generate_entries";
import { selectDefaultReducer } from "../redux/default/selectors";

const GenerateEntriesContainer = () => {
  const dispatch = useDispatch();

  const {
    products,
    selectedProductIds,
    selectInRevitUrl,
    channel,
    generatingEntries,
    generatingEntriesFailed,
    generateEntriesError
  } = useSelector(selectDefaultReducer);

  const selectedProducts = products.filter(p => selectedProductIds.includes(p.id));
  const entryGuids = selectedProducts.map(p => p.journalId);

  const onClick = (url, channel, entryGuids) => {
    dispatch(Action.generateEntries(url, channel, entryGuids));
  };

  return (
    <GenerateEntries
      selectInRevitUrl={selectInRevitUrl}
      channel={channel}
      entryGuids={entryGuids}
      generatingEntries={generatingEntries}
      generatingEntriesFailed={generatingEntriesFailed}
      generateEntriesError={generateEntriesError}
      onClick={onClick}
    />
  );
};

export default GenerateEntriesContainer;